import { render, staticRenderFns } from "./TodoDetail.vue?vue&type=template&id=0f9593c4&scoped=true&"
import script from "./TodoDetail.vue?vue&type=script&lang=js&"
export * from "./TodoDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9593c4",
  null
  
)

export default component.exports